export default __webpack_public_path__ + "static/media/relative.0ddeff44.png";